<template>
  <el-card shadow="hover" header="" class="x-card-title-slot">
    <div class="row no-gutters align-items-center" slot="header">
      <div class="col header-title">
        运费设置
      </div>
    </div>
    <div v-if="isShowJinLi" class="row " style="padding-left: 20px;">
      <div>
        运费说明：此处的运费规则不针对锦礼商城订单生效。锦礼商城订单中的运费按照京东锦礼商城提供为准。
      </div>
    </div>
    <el-form class="demo-ruleForm" :model="params" ref="params" :rules="rules" label-width="100px">
      <el-form-item label="运费模式选择" label-width="100px">
        <div style="margin-bottom:10px">
          <el-radio v-model="params.model" label="FREE_SHIPPING">免运费</el-radio><br />
          <el-radio v-model="params.model" label="UNIFORM_FREIGHT">所有商品统一设置运费模式</el-radio><br />
          <el-radio v-model="params.model" label="BY_GOODS_SOURCE">针对商品来源设置运费模式</el-radio><br />
          <!-- <el-radio-group v-model="params.model">
            <p v-for="(item, index) in modelList" :key="index">
              <el-radio :label="item.value">{{ item.name }}</el-radio><br />
            </p>
          </el-radio-group> -->
        </div>
      </el-form-item>
      <el-form-item label="平台运费设置" label-width="100px" v-show="params.model !== 'FREE_SHIPPING'">
        <span style="color: #cccccc; font-size: 13px;">
          说明：平台运费用于平台向企业端收取运费，运费的满足金额以订单中，商品的会员价为标准。运费金额随订单扣减 。（运费规则中不记录企业自有商品）
        </span>
        <br>
        <template v-if="params.model == 'UNIFORM_FREIGHT'">
          <span>平台运费按照满</span>
          <el-form-item style="display: inline-block" prop="uniform_freight.min" :rules="rules.min">
            <el-input v-model="params.uniform_freight.min" placeholder="输入金额" size="small"
              @input="handleInput(3, params.uniform_freight.min, 0)"></el-input>
          </el-form-item>
          <span>元包邮,不满则收取</span>
          <el-form-item style="display: inline-block" prop="uniform_freight.money" :rules="rules.money">
            <el-input v-model="params.uniform_freight.money" placeholder="输入金额" size="small"
              @input="handleInput(4, params.uniform_freight.money, 0)"></el-input>
            <span>元运费。</span>
          </el-form-item>
        </template>
        <template v-if="params.model === 'BY_GOODS_SOURCE'">
          <div class="ssf">
            <div class="ssf-title">
              <b>京东商品运费:</b>
              <p>平台商品运费规则:订单金额 < 59元，收取运费6元；订单金额 ≥ 59元， 免运费 </p>
                  <p>（未设置运费规则的价格区间按照免运费来计算）</p>
            </div>
            <div v-for="(k, index) in params.by_goods_source.JD_GOODS" :key="index"
              class="row no-gutters align-items-center">
              <div class="col-auto">
                <span>订单中商品金额在</span>
                <el-form-item class="flexitem" :prop="`by_goods_source.JD_GOODS[${index}].min`" :rules="rules.list_min">
                  <el-input v-model="k.min" placeholder="0.0" size="small"
                    @input="handleInput(0, k.min, index, 'JD_GOODS')"></el-input>
                  <span>元(包含)至</span>
                </el-form-item>
                <el-form-item class="flexitem" :prop="`by_goods_source.JD_GOODS[${index}].max`" :rules="rules.list_max">
                  <el-input v-model="k.max" placeholder="0.0" size="small"
                    @input="handleInput(1, k.max, index, 'JD_GOODS')"></el-input>
                  <span>元(不含),收取</span>
                </el-form-item>
                <el-form-item class="flexitem" :prop="`by_goods_source.JD_GOODS[${index}].money`"
                  :rules="rules.list_money">
                  <el-input v-model="k.money" placeholder="0.0" size="small"
                    @input="handleInput(2, k.money, index, 'JD_GOODS')"></el-input>
                  <span>元运费。</span>
                </el-form-item>
              </div>

              <div class="col-auto">
                <el-button v-if="index === 0" type="primary" @click="pub('JD_GOODS')" size="small">添加</el-button>
                <el-button v-else type="danger" @click="del(index, 'JD_GOODS')" size="small">删除</el-button>
              </div>
            </div>
          </div>
          <div class="ssf">
            <div class="ssf-title">
              <b>精选优品商品运费:</b>
              <p>所有平台精选优品类商品按照同一种运费规则来计算。</p>
              <p>（未设置运费规则的价格区间按照免运费来计算）</p>
            </div>
            <div v-for="(k, index) in params.by_goods_source.NORMAL" :key="index"
              class="row no-gutters align-items-center">
              <div class="col-auto">
                <span>订单中商品金额在</span>
                <el-form-item class="flexitem" :prop="`by_goods_source.NORMAL[${index}].min`" :rules="rules.list_min">
                  <el-input v-model="k.min" placeholder="0.0" size="small"
                    @input="handleInput(0, k.min, index, 'NORMAL')"></el-input>
                  <span>元(包含)至</span>
                </el-form-item>
                <el-form-item class="flexitem" :prop="`by_goods_source.NORMAL[${index}].max`" :rules="rules.list_max">
                  <el-input v-model="k.max" placeholder="0.0" size="small"
                    @input="handleInput(1, k.max, index, 'NORMAL')"></el-input>
                  <span>元(不含),收取</span>
                </el-form-item>
                <el-form-item class="flexitem" :prop="`by_goods_source.NORMAL[${index}].money`"
                  :rules="rules.list_money">
                  <el-input v-model="k.money" placeholder="0.0" size="small"
                    @input="handleInput(2, k.money, index, 'NORMAL')"></el-input>
                  <span>元运费。</span>
                </el-form-item>
              </div>

              <div class="col-auto">
                <el-button v-if="index === 0" type="primary" @click="pub('NORMAL')" size="small">添加</el-button>
                <el-button v-else type="danger" @click="del(index, 'NORMAL')" size="small">删除</el-button>
              </div>
            </div>
          </div>


          <!-- <div class="ssf">
            <div class="ssf-title">
              <b>蛋糕类商品运费:</b>
              <p>所有平台接入的蛋糕类商品按照同一种运费规则来计算。 </p>
              <p>（未设置运费规则的价格区间按照免运费来计算）</p>
            </div>
            <div v-for="(k, index) in params.by_goods_source.UNCLE_CAKE_GOODS" :key="index"
              class="row no-gutters align-items-center">
              <div class="col-auto">
                <span>订单中商品金额在</span>
                <el-form-item class="flexitem" :prop="`by_goods_source.UNCLE_CAKE_GOODS[${index}].min`" :rules="rules.list_min">
                  <el-input v-model="k.min" placeholder="0.0" size="small"
                    @input="handleInput(0, k.min, index, 'UNCLE_CAKE_GOODS')"></el-input>
                  <span>元(包含)至</span>
                </el-form-item>
                <el-form-item class="flexitem" :prop="`by_goods_source.UNCLE_CAKE_GOODS[${index}].max`" :rules="rules.list_max">
                  <el-input v-model="k.max" placeholder="0.0" size="small"
                    @input="handleInput(1, k.max, index, 'UNCLE_CAKE_GOODS')"></el-input>
                  <span>元(不含),收取</span>
                </el-form-item>
                <el-form-item class="flexitem" :prop="`by_goods_source.UNCLE_CAKE_GOODS[${index}].money`" :rules="rules.list_money">
                  <el-input v-model="k.money" placeholder="0.0" size="small"
                    @input="handleInput(2, k.money, index, 'UNCLE_CAKE_GOODS')"></el-input>
                  <span>元运费。</span>
                </el-form-item>
              </div>
              <div class="col-auto">
                <el-button v-if="index === 0" type="primary" @click="pub('UNCLE_CAKE_GOODS')"
                  size="small">添加</el-button>
                <el-button v-else type="danger" @click="del(index, 'UNCLE_CAKE_GOODS')" size="small">删除</el-button>
              </div>
            </div>
          </div> -->


        </template>
      </el-form-item>
      <el-button class="fixedbtn" type="primary" @click="handleSaveShopData()">确定</el-button>
    </el-form>
  </el-card>
</template>

<script>
import { getTransPort, saveTransPort } from '@/api/systemSetting'
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['shopInfo'])
  },
  name: 'transportg',
  data () {
    return {
      modelList: [
        { value: 'FREE_SHIPPING', name: '免运费' },
        { value: 'UNIFORM_FREIGHT', name: '所有商品统一设置运费模式' },
        { value: 'BY_GOODS_SOURCE', name: '针对商品来源设置运费模式' }
      ],
      activeName: '1',
      params: {
        model: 'FREE_SHIPPING',//运费设置选择
        uniform_freight: { min: '', money: '' },//统一运费设置
        by_goods_source: {
          //京东商品运费
          JD_GOODS: [{
            max: '',
            min: '',
            money: ''
          }],
          //精选优品商品运费
          NORMAL: [{
            max: '',
            min: '',
            money: ''
          }],
          //蛋糕商品运费
          UNCLE_CAKE_GOODS: [{
            max: '',
            min: '',
            money: ''
          }],
        }

      },
      rules: {
        min: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ],
        list_min: [
          {
            validator: (rule, value, callback) => {
              const reg = /^[1-9]\d*$|^[0-9]\d*.[0-9]{2}$|^[0-9]\d*.[0-9]$/
              const name = rule.field.split('.')[1].split('[')[0]
              const index = rule.field.split('.')[1].split('[')[1].charAt(0)
              const rule_one = this.params.by_goods_source[name][index].max != '' && this.params.by_goods_source[name][index].min == '';
              const rule_two = this.params.by_goods_source[name][index].max == '' && this.params.by_goods_source[name][index].min == '' && this.params.by_goods_source[name][index].money != '';
              if (rule_two) {
                callback(new Error('请输入金额'));
              } else if (this.params.by_goods_source[name][index].min != '' && this.params.by_goods_source[name][index].max != '') {
                if (Number(this.params.by_goods_source[name][index].min) >= Number(this.params.by_goods_source[name][index].max)) {
                  callback(new Error('右侧金额需大于左侧金额'));
                } else callback();
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        list_max: [
          {
            validator: (rule, value, callback) => {
              const reg = /^[1-9]\d*$|^[0-9]\d*.[0-9]{2}$|^[0-9]\d*.[0-9]$/
              const name = rule.field.split('.')[1].split('[')[0]
              const index = rule.field.split('.')[1].split('[')[1].charAt(0)
              if (this.params.by_goods_source[name][index].min != '') {
                if (Number(this.params.by_goods_source[name][index].min) >= Number(this.params.by_goods_source[name][index].max)) {
                  callback(new Error('右侧金额需大于左侧金额'));
                } else callback();
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        list_money: [
          {
            validator: (rule, value, callback) => {
              const reg = /^[1-9]\d*$|^[0-9]\d*.[0-9]{2}$|^[0-9]\d*.[0-9]$/
              const name = rule.field.split('.')[1].split('[')[0]
              const index = rule.field.split('.')[1].split('[')[1].charAt(0)
              if (this.params.by_goods_source[name][index].min != '' && this.params.by_goods_source[name][index].max != '' && this.params.by_goods_source[name][index].money == '') {
                callback(new Error('请设置运费'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
      }
    };
  },
  mounted () {
    this.getTongYi();
  },
  methods: {
    handleInput (type, val, index, name) {
      if (val !== '.' && val.slice(-1) === '.' && val.split('.').length - 1 < 2) {
        return true;
      }
      if (/^[0-9]\d*$|^[0-9]\d*.[0-9]\d*$/.test(val)) {
        let result = val;
        if (val.includes('.')) {
          const intPrice = val.split('.')[0]
          let flotPrice = val.split('.')[1]
          if (flotPrice.length > 2) {
            flotPrice = flotPrice.slice(0, 2)
          }
          result = intPrice.toString() + '.' + flotPrice.toString()
        }
        if (result > 10000) result = 10000
        if (type === 0) {
          this.params.by_goods_source[name][index].min = result
        } else if (type === 1) {
          this.params.by_goods_source[name][index].max = result
        } else if (type === 2) {
          this.params.by_goods_source[name][index].money = result
        } else if (type === 3) {
          this.params.uniform_freight.min = result
        } else {
          this.params.uniform_freight.money = result
        }
      } else {
        if (type === 0) {
          this.params.by_goods_source[name][index].min = ''
        } else if (type === 1) {
          this.params.by_goods_source[name][index].max = ''
        } else if (type === 2) {
          this.params.by_goods_source[name][index].money = ''
        } else if (type === 3) {
          this.params.uniform_freight.min = ''
        } else {
          this.params.uniform_freight.money = ''
        }
      }
    },
    del (ind, name) {
      this.params.by_goods_source[name].splice(ind, 1)
    },
    pub (name) {
      let temp = {
        max: '',
        min: '',
        money: ''
      };
      this.params.by_goods_source[name].push(temp);
    },
    /*** 保存运费设置*/
    handleSaveShopData () {


      this.$refs.params.validate((valid) => {
        console.log(this.params);
        console.log(valid);
        if (valid) {
          const params = {
            ...this.params
          }
          saveTransPort(params).then(res => {
            this.$message.success('保存成功！');
            this.getTongYi();
          });
        } else {
          this.$message.error('请填写完整信息！');
          return false;
        }
      });
    },
    /**查询运费详情 */
    getTongYi () {
      const contain_enterprise = true;
      getTransPort({ contain_enterprise }).then(res => {
        if (res) {
          const { by_goods_source, uniform_freight, model } = res
          //统一运费设置
          this.params = {
            uniform_freight: {
              min: '',
              money: ''
            },
            by_goods_source: {
              //京东商品运费
              JD_GOODS: [{ max: '', min: '', money: '' }],
              //精选优品商品运费
              NORMAL: [{ max: '', min: '', money: '' }],
              //蛋糕商品运费
              UNCLE_CAKE_GOODS: [{ max: '', min: '', money: '' }],
            },
            model: ''
          }
          this.params.model = model;
          if (uniform_freight) {
            this.params.uniform_freight = res.uniform_freight;
          }
          if (by_goods_source && JSON.stringify(by_goods_source) != "{}") {
            if (res.by_goods_source.JD_GOODS && JSON.stringify(res.by_goods_source.JD_GOODS) != "[]") this.params.by_goods_source.JD_GOODS = res.by_goods_source.JD_GOODS;
            if (res.by_goods_source.NORMAL && JSON.stringify(res.by_goods_source.NORMAL) != "[]") this.params.by_goods_source.NORMAL = res.by_goods_source.NORMAL;
            if (res.by_goods_source.UNCLE_CAKE_GOODS && JSON.stringify(res.by_goods_source.UNCLE_CAKE_GOODS) != "[]") this.params.by_goods_source.UNCLE_CAKE_GOODS = res.by_goods_source.UNCLE_CAKE_GOODS;
          }
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.ss {
  color: #999;
}

.ssf {
  line-height: 1.7;
  margin-top: 8px;

  .ssf-title {
    b {
      font-size: 15px;
    }

    p {
      color: #999;
    }
  }

  .row {
    margin-bottom: 16px;
  }
}

/deep/ {
  .el-input {
    width: 85px;
    margin: 0 8px;
  }
}

.flexitem {
  display: inline-block;
}

.fixedbtn {
  position: fixed;
  bottom: 4%;
  left: 47%;
}
</style>
